const rankingItems = [
  { rank: 1, tag: '电视剧', title: '星河之约', hot: '9.8', desc: '都市情感大戏，全网热度第一' },
  { rank: 2, tag: '电影', title: '暗夜追击', hot: '9.7', desc: '年度动作悬疑巨制口碑爆棚' },
  { rank: 3, tag: '电视剧', title: '长安旧事', hot: '9.6', desc: '古装权谋大戏全40集完结' },
  { rank: 4, tag: '综艺', title: '欢乐星期天', hot: '9.5', desc: '全网最火综艺笑点不断' },
  { rank: 5, tag: '动漫', title: '山海传说', hot: '9.4', desc: '热门国漫第三季即将上线' },
];

const rankColors: Record<number, string> = {
  1: 'bg-primary-500 text-background-50',
  2: 'bg-accent-500 text-background-50',
  3: 'bg-secondary-500 text-background-50',
  4: 'bg-background-200 text-foreground-600',
  5: 'bg-background-200 text-foreground-600',
};

export default function RankingSection() {
  return (
    <section id="ranking" className="py-14 md:py-20 px-4 md:px-6 bg-background-50">
      <div className="max-w-3xl mx-auto">
        <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 font-heading text-center mb-4">热播榜单</h2>
        <p className="text-sm text-foreground-500 text-center mb-10">全网热播影视实时热度排行</p>

        <div className="space-y-3">
          {rankingItems.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="group flex items-center gap-4 p-4 rounded-2xl bg-background-100 border border-background-200/70 hover:border-primary-200 hover:-translate-x-1 transition-all duration-300 cursor-pointer"
              onClick={(e) => e.preventDefault()}
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-xl font-bold text-sm ${rankColors[item.rank]}`}>
                {item.rank}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2 mb-1">
                  <span className="px-2 py-0.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium whitespace-nowrap">{item.tag}</span>
                  <h3 className="text-sm font-bold text-foreground-900 whitespace-nowrap">{item.title}</h3>
                </div>
                <p className="text-xs text-foreground-500">{item.desc}</p>
              </div>
              <div className="flex-shrink-0 text-right">
                <div className="flex items-center gap-1">
                  <i className="ri-fire-fill text-accent-500 text-sm"></i>
                  <span className="text-lg font-black text-foreground-900 font-heading">{item.hot}</span>
                </div>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}